/**
 * Comment class
 * 
 * Represents a comment on a BGG item.
 */
class Comment {
    constructor(author, body, time) {
        this.author = author;
        this.body = body;
        this.time = time;
    }
}

export default Comment;